/* eslint-disable eqeqeq */
import React, { Fragment, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  IconButton,
  Button,
  Tooltip,
  TextField,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import DoneIcon from "@material-ui/icons/Done";
import PropTypes from "prop-types";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";

const useStyles = makeStyles(() => ({
  deliveryStatusTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 10,
  },
  dialogTitle: {
    fontSize: 18,
    color: "#1558a2",
    fontWeight: 700,
  },
  button: {
    fontSize: 12,
    textTransform: "capitalize",
    marginRight: 5,
    marginLeft: 5,
  },
  subStatusTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 10,
    marginTop: 10,
  },
  actions: {
    marginTop: 20,
    float: "right",
  },
  orderWarningMsg: {
    marginBottom: 10,
    marginRight: 10,
    marginLeft: 10,
    color: "grey",
    fontSize: 12,
    textAlign: "center",
    backgroundColor: "antiquewhite",
    padding: 6,
  },
}));

const C13ChangeDeliveryStatusCPRDialog = (props) => {
  const classes = useStyles();
  const { handleClose, open, onHandleChange, state, onSaveClick } = props;
  const [initialState, setInitialState] = useState({
    changeCprStatusId: 0,
    changeCprIncomeStatusId: 0,
    changeCprJazzCashIncomeStatusId: 0,
  });

  useEffect(() => {
    if (open) {
      setInitialState({
        changeCprStatusId: state.changeCprStatusId,
        changeCprIncomeStatusId: state.changeCprIncomeStatusId,
        changeCprJazzCashIncomeStatusId: state.changeCprJazzCashIncomeStatusId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Fragment>
      <ControlledDialog
        open={open}
        disableBackdropClick
        disableEscapeKeyDown={state.changeStatusLoading}
        handleClose={() => handleClose()}
        title={
          <Fragment>
            <Tooltip title="Back">
              <IconButton
                disabled={state.changeStatusLoading}
                onClick={() => handleClose()}
              >
                <ArrowBackIcon fontSize="small" color="primary" />
              </IconButton>
            </Tooltip>
            {state.paymentMethodTypeId != 4 ?
              <span
                className={classes.dialogTitle}
              >{`${state.selectedOrder.orderId} - ${state.selectedOrder.deliveryPartnerLabel} - (${state.selectedOrder.statusLabel})`}</span> :

              <span
                className={classes.dialogTitle}
              >{`${state.selectedOrder.orderId}`} - Jazz Cash CPR </span>
            }

          </Fragment>
        }
        content={
          <Fragment>
            {/* {state.selectedOrder.orderStatusId == 21 && (
              <div className={classes.orderWarningMsg}>
                <b>NOTE :</b> Order is in returned state So, we can not change
                the status from this dialog.
              </div>
            )} */}

            {state.paymentMethodTypeId != 4 ?
              <>
                <div className={classes.deliveryStatusTitle}>CPR Sales Tax *</div>
                <div>
                  <Button
                    name="changeCprStatusId"
                    id="changeCprStatusId"
                    disabled={
                      initialState.changeCprStatusId == 1 ||
                      state.changeStatusLoading
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      const value = state.changeCprStatusId == 1 ? 0 : 1;
                      onHandleChange({
                        target: {
                          name: "changeCprStatusId",
                          value: value,
                        },
                      });
                    }}
                    value={state.changeCprStatusId}
                    variant={state.changeCprStatusId == 1 ? "contained" : "outlined"}
                    color="primary"
                    className={classes.button}
                    startIcon={state.changeCprStatusId == 1 ? <DoneIcon /> : null}
                  >
                    CPR Received
                  </Button>

                </div>
                <div className={classes.subStatusTitle}>
                  CPR Income Tax
                </div>
                <div>
                  <Button
                    name="changeCprIncomeStatusId"
                    id="changeCprIncomeStatusId"
                    disabled={
                      initialState.changeCprIncomeStatusId == 1 ||
                      state.changeStatusLoading
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      const value = state.changeCprIncomeStatusId == 1 ? 0 : 1;
                      onHandleChange({
                        target: {
                          name: "changeCprIncomeStatusId",
                          value: value,
                        },
                      });
                    }}
                    value={state.changeCprIncomeStatusId}
                    variant={
                      state.changeCprIncomeStatusId == 1 ? "contained" : "outlined"
                    }
                    color="primary"
                    className={classes.button}
                    startIcon={state.changeCprIncomeStatusId == 1 ? <DoneIcon /> : null}
                  >
                    CPR Income Tax Received
                  </Button>
                </div>
              </>
              :
              <>
                <div className={classes.subStatusTitle}>
                  CPR Jazz Cash Tax
                </div>
                <div>
                  <Button
                    name="changeCprJazzCashIncomeStatusId"
                    id="changeCprJazzCashIncomeStatusId"
                    disabled={
                      initialState.changeCprJazzCashIncomeStatusId == 1 ||
                      state.changeStatusLoading
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      const value = state.changeCprJazzCashIncomeStatusId == 1 ? 0 : 1;
                      onHandleChange({
                        target: {
                          name: "changeCprJazzCashIncomeStatusId",
                          value: value,
                        },
                      });
                    }}
                    value={state.changeCprJazzCashIncomeStatusId}
                    variant={
                      state.changeCprJazzCashIncomeStatusId == 1 ? "contained" : "outlined"
                    }
                    color="primary"
                    className={classes.button}
                    startIcon={state.changeCprJazzCashIncomeStatusId == 1 ? <DoneIcon /> : null}
                  >
                    CPR Income Tax Received
                  </Button>
                </div>
              </>
            }



            <div
              style={{
                margin: 10,
              }}
            >
              <TextField
                fullWidth
                id="changeStatusRemarks"
                name="changeStatusRemarks"
                label="Remarks"
                value={state.changeStatusRemarks}
                type="text"
                variant={"outlined"}
                onChange={onHandleChange}
                size="small"
                margin="dense"
                multiline
                rows={3}
                disabled={
                  state.changeStatusLoading ||
                  state.selectedOrder.orderStatusId == 21
                }
                InputProps={{
                  style: { fontSize: "12px" }, // Adjust font size for input text
                }}
                InputLabelProps={{
                  style: { fontSize: "12px" }, // Adjust font size for label text
                }}
              />
            </div>
            <Divider />
            <div className={classes.actions}>
              <Button
                variant="contained"
                color="default"
                size="small"
                className={classes.button}
                disabled={state.changeStatusLoading}
                onClick={(e) => {
                  e.preventDefault();
                  handleClose();
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes.button}
                disabled={
                  state.changeStatusLoading ||
                  state.selectedOrder.orderStatusId == 21
                }
                onClick={(e) => onSaveClick(e)}
              >
                {state.changeStatusLoading ? (
                  <CircularProgress size={22} color="primary" />
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </Fragment>
        }
      />
    </Fragment>
  );
};

C13ChangeDeliveryStatusCPRDialog.propTypes = {
  handleClose: PropTypes.func,
  onHandleChange: PropTypes.func,
  onSaveClick: PropTypes.func,
  open: PropTypes.bool,
  state: PropTypes.object,
};

C13ChangeDeliveryStatusCPRDialog.defaultProps = {
  handleClose: (fn) => fn,
  onHandleChange: (fn) => fn,
  onSaveClick: (fn) => fn,
  open: false,
  state: {},
};

export default C13ChangeDeliveryStatusCPRDialog;
